import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Footer from '../../../components/feature/Footer';
import TableOfContents, { generateTocItems } from '../../../components/feature/TableOfContents';
import ArticlePartOne from './components/ArticlePartOne';
import ArticlePartTwo from './components/ArticlePartTwo';
import ArticlePartThree from './components/ArticlePartThree';
import ArticlePartFour from './components/ArticlePartFour';

const tocItems = generateTocItems([
  'Why Divorce Makes Selling a House So Complicated',
  'Texas Community Property Law and Your Home',
  'Your Four Options for the Marital Home',
  'Why a Cash Sale Is Often the Best Divorce Exit Strategy',
  'The Divorce Home Sale Timeline in El Paso',
  'What Happens If One Spouse Refuses to Sell',
  'How to Protect Your Equity During a Divorce Sale',
  'Tax Implications of Selling During Divorce in Texas',
  'Common Mistakes El Paso Couples Make When Selling',
  'Frequently Asked Questions',
  'Moving Forward After the Sale',
]);

export default function SellHouseDivorceElPaso() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-black rounded-lg flex items-center justify-center">
              <i className="ri-home-4-fill text-[#D4AF37] text-xl"></i>
            </div>
            <span className="text-xl font-bold text-black">Cash For Houses El Paso</span>
          </Link>
          <div className="hidden md:flex items-center gap-8">
            <Link to="/#how-it-works" className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer">
              How It Works
            </Link>
            <Link to="/#about-elpaso" className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer">
              About El Paso
            </Link>
            <Link to="/#benefits" className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer">
              Benefits
            </Link>
            <Link to="/get-cash" className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer">
              Blog
            </Link>
            <Link to="/#faq" className="text-sm font-medium text-gray-700 hover:text-black transition-colors whitespace-nowrap cursor-pointer">
              FAQ
            </Link>
            <a href="tel:9157457883" className="px-6 py-2.5 bg-black text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer">
              Call: 915-745-7883
            </a>
          </div>
          <div className="md:hidden">
            <a href="tel:9157457883" className="px-4 py-2 bg-black text-white text-sm font-semibold rounded-full whitespace-nowrap cursor-pointer">
              Call Now
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/get-cash" className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-black transition-colors mb-8 cursor-pointer">
            <i className="ri-arrow-left-line"></i>
            Back to Blog
          </Link>

          <div className="mb-8">
            <span className="inline-block px-4 py-1.5 bg-[#D4AF37] text-white text-xs uppercase font-semibold rounded-full mb-4">
              DIVORCE &amp; REAL ESTATE
            </span>
            <h1 className="text-5xl md:text-6xl font-bold text-black mb-6 leading-tight">
              Sell Your House During a Nasty Divorce in El Paso: The Complete Survival Guide
            </h1>
            <div className="flex items-center gap-6 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-user-line"></i>
                <span>Cash For Houses El Paso</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>22 min read</span>
              </div>
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-xl mb-12 h-96">
            <img
              src="https://public.readdy.ai/ai/img_res/49a93496381927e7ef8b0074f3aa2bb1.jpg"
              alt="Selling house during divorce in El Paso Texas"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg max-w-none">
          <ArticlePartOne />
          
          <TableOfContents items={tocItems} />
          
          <ArticlePartTwo />
          <ArticlePartThree />
          <ArticlePartFour />
        </div>

        {/* Call to Action */}
        <div className="mt-16 p-12 bg-gradient-to-br from-black to-gray-900 rounded-3xl text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Going Through a Divorce? We Can Help You Sell Fast.
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Get a fair cash offer within 24 hours. Close in as little as 7 days. No repairs, no showings, no agent disputes. Both spouses walk away with a clean financial break.
          </p>
          <a href="tel:9157457883" className="inline-block px-8 py-4 bg-[#D4AF37] text-white text-lg font-semibold rounded-full hover:bg-[#B8941F] transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-phone-fill mr-2"></i>Call 915-745-7883 Now
          </a>
        </div>

        {/* Related Posts */}
        <div className="mt-24">
          <h3 className="text-3xl font-bold text-black mb-8">Related Articles</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Link to="/get-cash/sell-house-fast-el-paso" className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border border-gray-100">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20home%20selling%20process%20with%20documents%20and%20keys%20on%20desk%2C%20real%20estate%20transaction%20paperwork%2C%20professional%20business%20setting%20with%20warm%20lighting%2C%20clean%20organized%20workspace%20photography&width=600&height=400&seq=blog-001&orientation=landscape"
                  alt="Sell house fast in El Paso"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-[#D4AF37] text-white text-xs uppercase font-semibold rounded-full mb-3">
                  SELLING TIPS
                </span>
                <h4 className="text-lg font-semibold text-black mb-2">How to Sell Your House Fast in El Paso</h4>
                <p className="text-sm text-gray-600">Discover the fastest methods to sell your El Paso home.</p>
              </div>
            </Link>

            <Link to="/get-cash/el-paso-closing-costs-seller-fees" className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border border-gray-100">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=real%20estate%20closing%20documents%20and%20settlement%20statement%20spread%20on%20polished%20wooden%20conference%20table%20with%20pen%20and%20house%20keys%2C%20professional%20title%20company%20office%20setting%20with%20warm%20natural%20lighting&width=600&height=400&seq=closing-costs-related-001&orientation=landscape"
                  alt="El Paso closing costs"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-[#D4AF37] text-white text-xs uppercase font-semibold rounded-full mb-3">
                  CLOSING COSTS
                </span>
                <h4 className="text-lg font-semibold text-black mb-2">El Paso Closing Costs &amp; Seller Fees</h4>
                <p className="text-sm text-gray-600">Know exactly what you'll pay when selling your home.</p>
              </div>
            </Link>

            <Link to="/get-cash/cant-pay-mortgage-el-paso" className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border border-gray-100">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=stressed%20homeowner%20sitting%20at%20kitchen%20table%20with%20mortgage%20bills%20and%20past%20due%20notices%20spread%20out%2C%20worried%20expression%20looking%20at%20financial%20documents%2C%20warm%20natural%20lighting%20through%20window&width=600&height=400&seq=mortgage-related-001&orientation=landscape"
                  alt="Can't pay mortgage"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-[#D4AF37] text-white text-xs uppercase font-semibold rounded-full mb-3">
                  FORECLOSURE
                </span>
                <h4 className="text-lg font-semibold text-black mb-2">Can&apos;t Pay the Mortgage in El Paso?</h4>
                <p className="text-sm text-gray-600">What happens and how to stop foreclosure.</p>
              </div>
            </Link>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}
